import { render, staticRenderFns } from "./UploadBlank.vue?vue&type=template&id=4722979e&scoped=true&"
import script from "./UploadBlank.vue?vue&type=script&lang=js&"
export * from "./UploadBlank.vue?vue&type=script&lang=js&"
import style0 from "./UploadBlank.vue?vue&type=style&index=0&id=4722979e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4722979e",
  null
  
)

export default component.exports